import { MessageType } from "./global-message.interface";

export const iconForMessageType = {
  [MessageType.primary]: 'exclamation-triangle',
  [MessageType.secondary]: 'info-circle',
  [MessageType.success]: 'check-circle',
  [MessageType.danger]: 'exclamation-triangle',
  [MessageType.warning]: 'exclamation-triangle',
  [MessageType.info]: 'info-circle',
};
export const getMessageIcon = (type: string): string | undefined => {
  return iconForMessageType[type];
}

